import { LitElement } from 'lit';
import { Constructable } from './types';

const NON_CANCELABLE_EVENTS = new Set([
	// Focus events
	'focus',
	'blur',
	'focusin',
	'focusout',
	// Input events
	'input',
	'change',
	// Media events
	'play',
	'pause',
	'ended',
	'volumechange',
	'timeupdate',
	'durationchange',
	'loadeddata',
	'loadedmetadata',
	'loadstart',
	'canplay',
	'canplaythrough',
	'playing',
	'seeked',
	'stalled',
	'suspend',
	'waiting',
	'ratechange',
	// Lifecycle/window events
	'load',
	'unload',
	'abort',
	'error',
	'resize',
	'scroll',
	// Keyboard
	'keyup',
	// Misc
	'reset',
	'select',
]);

export interface SDSEventDispatcherMixinInterface {
	dispatchSheriffEvent<TDetail = void>(type: string, detail?: TDetail, cancelable?: boolean): boolean;
	dispatchKeyboardEvent(type: string, originalEvent: KeyboardEvent): boolean;
}

export function SDSEventDispatcherMixin<T extends Constructable<LitElement>>(superClass: T): Constructable<SDSEventDispatcherMixinInterface> & T {
	return class SDSEventDispatcher extends superClass {
		dispatchSheriffEvent<TDetail = void>(type: string, detail?: TDetail, cancelable = !NON_CANCELABLE_EVENTS.has(type)): boolean {
			return this.dispatchEvent(
				new CustomEvent<TDetail>(type, {
					detail,
					bubbles: true,
					composed: true,
					cancelable,
				})
			);
		}

		dispatchKeyboardEvent(type: string, originalEvent: KeyboardEvent): boolean {
			return this.dispatchEvent(
				new KeyboardEvent(type, {
					key: originalEvent.key,
					code: originalEvent.code,
					bubbles: true,
					composed: true,
					cancelable: !NON_CANCELABLE_EVENTS.has(type),
					ctrlKey: originalEvent.ctrlKey,
					shiftKey: originalEvent.shiftKey,
					altKey: originalEvent.altKey,
					metaKey: originalEvent.metaKey,
					repeat: originalEvent.repeat,
					isComposing: originalEvent.isComposing,
					location: originalEvent.location,
				})
			);
		}
	};
}
